import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const Report = lazy(() => import("./Report"));

const L = DefaultLayout;
const W = withSuspense;

export function getReportRoutes() {
  return [
    { path: "/report/:id/supplier/:suppliercode", layout: L, element: W(Report) },
    { path: "/report/:id", layout: L, element: W(Report) },
  ];
}
